import { Reducer, Action } from "redux";
import { IAlertState, KnownAction, RECEIVE_ALERT_DATA, SHOW_LOADER } from "./types";

export const reducer: Reducer<IAlertState> = (state: IAlertState | undefined, incomingAction: Action): IAlertState => {
    if (state === undefined) {
        return { isAlertLoading: false };
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case RECEIVE_ALERT_DATA:
            return {
                ...state,
                alertData: action.alertData,
            };
        case SHOW_LOADER:
            return {
                ...state,
                isAlertLoading: action.isAlertLoading,
            };
        default:
            return state;
    }
};
